import SectionTitle from "features/無料占いコンテンツ/components/atoms/SectionTitle";
import ContentsCard from "features/無料占いコンテンツ/components/organisms/ContentsCard";
import { FreeFortuneDivination, FreeFortuneTag } from "shared/types";

import { useFreeFortuneContentList } from "repositories/hooks/useFreeFortuneContentList";

interface Props {
  tag: FreeFortuneTag;
  divination: FreeFortuneDivination;
  className?: string;
}

export const RelatedContentsTagDivination = ({
  tag,
  divination,
  className,
}: Props) => {
  const { freeFortuneContents, isLoading, isError } = useFreeFortuneContentList(
    {
      tagId: tag.id,
      divinationId: divination.id,
    }
  );

  if (isLoading || isError) return null;

  return (
    <div tw="px-4" className={className}>
      <div tw="my-5">
        <SectionTitle
          readMore
          readMoreLink={`/free_fortune/tag/${tag.id}/type/${divination.id}`}
        >
          {tag.name + divination.name}のおすすめ無料占い
        </SectionTitle>
      </div>

      <ul>
        {freeFortuneContents.map((content) => (
          <li key={content.id}>
            <ContentsCard freeFortuneContent={content} />
          </li>
        ))}
      </ul>
    </div>
  );
};
